import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface StatusBadgeProps {
  status?: string
  role?: string
  className?: string
}

const statusVariantMap: Record<string, string> = {
  // Status
  active: 'success',
  inactive: 'default',
  suspended: 'error',
  pending: 'warning',
  completed: 'success',
  approved: 'success',
  rejected: 'error',
  failed: 'error',
  refunded: 'warning',
  // Feedback statuses
  new: 'info',
  reviewed: 'warning',
  resolved: 'success',
  // Config request statuses (card 93) — pending/approved/rejected already mapped above
  applied: 'primary',
  // Knowledge base statuses (change: excel-knowledge-bases)
  uploaded: 'info',
  parsing: 'warning',
  indexing: 'warning',
  ready: 'success',
  error: 'error',
  // Roles
  super_admin: 'primary',
  admin: 'info',
  finance: 'success',
  support: 'info',
  user: 'default',
}

const statusLabels: Record<string, string> = {
  active: 'Activo',
  inactive: 'Inactivo',
  suspended: 'Suspendido',
  pending: 'Pendiente',
  completed: 'Completado',
  approved: 'Aprobado',
  rejected: 'Rechazado',
  failed: 'Fallido',
  refunded: 'Reembolsado',
  new: 'Nuevo',
  reviewed: 'Revisado',
  resolved: 'Resuelto',
  applied: 'Aplicado',
  uploaded: 'Subido',
  parsing: 'Procesando',
  indexing: 'Indexando',
  ready: 'Listo',
  error: 'Error',
  super_admin: 'Super Admin',
  admin: 'Administrador',
  finance: 'Finanzas',
  support: 'Soporte',
  user: 'Usuario',
}

export function StatusBadge({ status, role, className }: StatusBadgeProps) {
  const value = status || role || ''
  const variant = (statusVariantMap[value] || 'default') as
    | 'success'
    | 'error'
    | 'warning'
    | 'primary'
    | 'info'
    | 'default'
  const label = statusLabels[value] || (value ? value : 'Usuario')

  return (
    <Badge className={cn(className)} variant={variant}>
      {label}
    </Badge>
  )
}
